import {
  EApproveType,
  ECompanyApproveStatus,
  ETaxSourceSettleStatus,
  IAgentMergeInfo,
  IAgentOptionsItem,
  IAgentsQueryParam,
  IBusinessLineItem,
  ICompanyChangeRecord,
  ICompanyMergeInfo,
  ICompanyQueryParam,
  IEnterpriseItem,
  IIdentityItem,
  IIdentityParam,
  IPaymentChannel,
  ISecuritySettingDetail,
  IServerMergeInfo,
  IServerOptionsItem,
  IUpperSetupAgent,
  IUserRoleDetail,
} from '../types/common';
import { EAxiosResponseCode, ESystemType, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IServerInvoiceItem } from '../types/crowd-source/product';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账产品 - 上级代理商查询
 */
export async function queryUpperSetupAgents(agentId: number) {
  let data = [] as IUpperSetupAgent[];

  try {
    const { code, context, message } = await Http.get<IUpperSetupAgent[]>(
      `${hostUrl}/side/agent/getParentAgentList`,
      { agentId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 代理商用户 - 代理商列表
 * @param isHaveOwner 是否包含自己 默认 false
 */
export async function queryAgentList(params = {} as IAgentsQueryParam, isHaveOwner = false) {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IAgentOptionsItem>>(`${hostUrl}/side/agent/${isHaveOwner ? 'listHaveOwner' : 'list'}`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 代理商变更 - 获取待变更所属的代理商(特代、一代列表)
 */
export async function queryPreChangeAgentList() {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.get<Array<IAgentOptionsItem>>(`${hostUrl}/side/change/agent-belong/pre-change-agent`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 代理商用户 - 获取待升级特代的代理商
 */
export async function queryPreUpgradeAgentList() {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.get<Array<IAgentOptionsItem>>(`${hostUrl}/side/change/agent-belong/pre-upgrade-agent`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 企业用户 - 企业列表
 */
export async function queryEnterpriseList(params?: ICompanyQueryParam) {
  let data = [] as IEnterpriseItem[];

  try {
    const { code, context, message } = await Http.post<Array<IEnterpriseItem>>(`${hostUrl}/side/company/list`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 服务商列表
 */
export async function queryServerList(params?: {enable?: number; serverName?: string; settleStatus?: ETaxSourceSettleStatus}) {
  let data = [] as IServerOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IServerOptionsItem>>(`${hostUrl}/side/server/list`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 根据特代查询服务商列表
 */
export async function queryServerListFormAgent(params: {id: number}) {
  let data = [] as IServerOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IServerOptionsItem>>(`${hostUrl}/side/server/listForAgent`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/** 查询代理商明细信息 */
export async function queryAgentDetail(id?: number) {
  let data = {} as IAgentMergeInfo;

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/side/agent/detail`, { id: id || undefined });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as IAgentMergeInfo;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询企业明细信息
 * @param id 企业ID
 * @param snapshotId 快照ID
 * @returns 企业明细信息
 */
export async function queryComapnyDetail(id?: number, snapshotId?: number) {
  let data = {} as ICompanyMergeInfo;

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/side/company/detail`, {
      id: id || undefined,
      snapshotId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as ICompanyMergeInfo;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 查询服务商明细信息 */
export async function queryServerDetail(id?: number) {
  let data = {} as IServerMergeInfo;

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/side/server/detail`, { id: id || undefined });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as IServerMergeInfo;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询企业变更记录
 * @param id 企业ID
 * @returns 企业变更记录
 */
export async function queryCompanyChangeRecord(id?: number, snapshotId?: number) {
  let data = {} as ICompanyChangeRecord;

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/side/company/edit-detail`, {
      id: id || undefined,
      snapshotId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as ICompanyChangeRecord;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 获取支付通道选项 */
export async function queryChannels(enabled?: boolean, name?: string) {
  let data: IPaymentChannel[] = [];

  try {
    const { code, context, message } = await Http.get<IPaymentChannel[]>(`${hostUrl}/disburse/channel/list`, {
      enabled: enabled || undefined,
      name: name || undefined,
    });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询代理商、企业菜单
 * @param systemType {@link ESystemType}
 */
export async function queryAccountTreeData(systemType: ESystemType, id?: number) {
  let data = {} as IUserRoleDetail;

  const parmas = systemType === ESystemType.Agent
    ? {
      systemType,
      agentId: id,
    }
    : systemType === ESystemType.Company
      ? {
        systemType,
        companyId: id,
      }
      : null;

  try {
    const { code, context, message } = await Http.post<IUserRoleDetail>(`${hostUrl}/iam/menu/detail`, parmas);

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as IUserRoleDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 查询服务商明细信息 */
export async function queryInvoiceSubList(invoiceSubType = 0) {
  let data = [] as IServerInvoiceItem[];

  try {
    const { code, context, message } = await Http.post<IServerInvoiceItem[]>(`${hostUrl}/side/sys/invoiceSub/listTree`, { invoiceSubType });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || [];

      data = res || [] as IServerInvoiceItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 查询身份列表 */
export async function queryIdentityList(param: IIdentityParam) {
  let data = [] as IIdentityItem[];

  try {
    const { code, context, message } = await Http.get<IIdentityItem[]>(`${hostUrl}/iam/identity/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || [];

      data = res || [] as IIdentityItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 查询业务线列表 */
export async function queryBusinessLineList() {
  let data = [] as IBusinessLineItem[];

  try {
    const { code, context, message } = await Http.get<IBusinessLineItem[]>(`${hostUrl}/iam/business/list-owner`);

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || [];

      data = res || [] as IBusinessLineItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询侧边栏菜单权限
 * @param menuName 菜单名称
 */
export async function checkSideMenuPermission({ menuName, permissionCode }: { menuName?: string; permissionCode?: string }) {
  let status = 1;

  try {
    const { code, context, message } = await Http.get<number>(`${hostUrl}/iam/menu/permission`, {
      name: menuName || undefined,
      code: permissionCode || undefined,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }

    status = context || 0;
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return status;
}

/**
 * 查询企业编辑状态
 * @param id 企业ID
 */
export async function checkCompanyEditStatus(id: number) {
  let status = null as ECompanyApproveStatus;

  try {
    const { code, context, message } = await Http.post<number>(`${hostUrl}/side/company/approve-status`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }

    status = context || null as ECompanyApproveStatus;
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return status;
}

/**
 * 系统管理 - 安全设置详情
 */
export async function querySecuritySettingDetail(id: number, type: ESystemType) {
  let data = {} as ISecuritySettingDetail;

  const url = type === ESystemType.Agent ? 'agentPay/detail' : type === ESystemType.Company ? 'companyPay/detail' : 'server/pay/detail';

  try {
    const { code, context, message } = await Http.post<ISecuritySettingDetail>(`${hostUrl}/side/${url}`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as ISecuritySettingDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 审批管理 - 获取taskNos
 */
export async function queryTaskNos(refIds: number[], type: EApproveType) {
  let taskNos = [] as string[];

  try {
    const { code, context, message } = await Http.post<Array<string>>(`${hostUrl}/iam/approve/task/get-task-no-list`, {
      refIds,
      type,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      taskNos = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return taskNos;
}

export const UploadImageUrls = {
  license: getHostbaseUrl() + '/infra-center/upload/business/license/pic',
  idNoFront: getHostbaseUrl() + '/infra-center/upload/idNo/front/pic',
  idNoBack: getHostbaseUrl() + '/infra-center/upload/idNo/back/pic',
  bankCard: getHostbaseUrl() + '/infra-center/upload/bank-card',
  normal: getHostbaseUrl() + '/infra-center/upload/pic',
};

export const UploadFileUrls = { 
  normal: getHostbaseUrl() + '/infra-center/upload/uploadFile',
  pdf: getHostbaseUrl() + '/infra-center/upload/uploadPdf',
};
